import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/Card';
import Layout from '../components/Modular/Layout';
import Section from '../components/Modular/Section';
import Unit from '../components/Modular/Unit';
import Button from '../components/Button';
import { useWindowSize } from '../hooks/useWindowSize';
import { AthenaCore } from 'athena-core';
import { useQuery } from '../hooks/useQuery';
import DropDown from '../components/DropDown/DropDown';
import { useVerifyEmailToken } from '../hooks/useVerifyEmailToken';
import SendRecoveryEmailForm from '../components/Auth/SendRecoveryEmailForm';
import ResetPasswordForm from '../components/Auth/ResetPasswordForm';
import LoadingSpinner from '../components/LoadingSpinner';

export const ResetPasswordPage = () => {
  const query = useQuery();
  const token = query.get('token');
  const email = query.get('email');
  const { loading, passwordResetVerified, verifyPasswordResetToken } =
    useVerifyEmailToken(token);

  useEffect(() => {
    const verifyPassword = async () => {
      await verifyPasswordResetToken();
    };

    verifyPassword();
  }, [token]);

  const windowSize = useWindowSize();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
  };

  const context = {
    section: {
      layout: 'grid',
      justifyItems: 'center',
      background: 'dark',
      gap: 'md',

      // padding: 'py-6',
    },
    unit: {
      colSpan: '1',
      rowSpan: '1',
    },
  };

  return (
    <>
      <Layout
        layout="grid"
        gap="md"
        background="dark"
        alignContent="center"
        justifyItems="center"
        context={context}
      >
        <Section layout="grid" background="dark">
          <Card
            title="Reset Password"
            subtitle="Click on the link below to receive an email to reset your password"
            className=""
            context=""
            footer={
              <Unit gap="sm" justifyContent="flex-left">
                <Link to="/">
                  <Button variant="primary">Back To Home</Button>
                </Link>
              </Unit>
            }
          >
            {!loading && !passwordResetVerified && (
              <SendRecoveryEmailForm></SendRecoveryEmailForm>
            )}

            {loading && !passwordResetVerified && (
              <LoadingSpinner></LoadingSpinner>
            )}

            {!loading && passwordResetVerified && (
              <ResetPasswordForm email={email}></ResetPasswordForm>
            )}
          </Card>
        </Section>
      </Layout>
    </>
  );
};
